<template>
  <div class="pt-5">
    <v-skeleton-loader v-if="profileSectionLoading" v-bind="attrs" type="card" />
    <div v-else-if="profileSection && profileSection.visibilityInteraction">
      <div v-for="(setting, i) in profileSection.visibilityInteraction" :key="i">
        <div v-if="setting.block_name === 'visibilityInteraction'">
          <div style="background-color: #f3f3f6" v-for="(item, index) in setting.block_data"
               :key="index"
          >
            <div v-if="item.field === 'show_user_list'" class="visibility-page">
              {{item.title}}
              <div
                  @click="toggleStatus(item)"
                  :style="{backgroundColor: !item.value ? '#9b9b9b' : 'var(--secondary_color)'}"
                  class="session-question-form__anonymous-wrapper__button"
              >
                <div :style="{ transform: item.value ? 'translateX(20px)' : 'translateX(0)' }"
                     class="session-question-form__anonymous-wrapper__button__circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'VisibilityProfile',
  data(){
    return {
      attrs: {
        elevation: 0,
      },
    }
  },
  methods:{
    ...mapActions('app',['setPageTitle']),
    ...mapActions('auth',['getProfileSection', 'visibilityChange', 'clearProfileSection']),
    async toggleStatus(item) {
      const newValue = item.value ? 0 : 1
      item.value = newValue

      try {
        await this.visibilityChange(
        { [item.field]: newValue }
        )
      } catch (e) {
        console.error(e)
        item.value = newValue ? 0 : 1
      }
    }
  },
  computed:{
    ...mapGetters('auth',['profileSection', 'profileSectionLoading','profileSectionError']),
  },
  mounted() {
    this.setPageTitle('Visibility & Interaction');
  },
  created(){
    this.getProfileSection('visibilityInteraction');
  },
  beforeDestroy(){
    this.setPageTitle('');
    this.clearProfileSection()
  }
}

</script>

<style lang="scss">
.visibility-page{
  display: flex;
  width: 100%;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  margin-bottom: 8px;
  color: #4a4a4a;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;

}

</style>